import React from 'react'
import { Link } from 'react-router-dom'

const ACTIONS = [
  { to: '/stores', emoji: '✅', label: 'Verified Sellers', colors: ['#0EA899', '#14b8a6', '#0D9488'], shadow: 'rgba(20,184,166,0.4)' },
  { to: '/products/search?category=&value=', emoji: '🔥', label: 'Hot Deals', colors: ['#F55A5A', '#ef4444', '#DC2626'], shadow: 'rgba(239,68,68,0.4)' },
  { to: '/products?category=', emoji: '⭐', label: 'Top Listings', colors: ['#FBAD3C', '#fb923c', '#EA7C0B'], shadow: 'rgba(251,146,60,0.4)' },
]

const QuickActions = () => {
  return (
    <div
      className="flex justify-center items-center gap-2 sm:gap-1.5 w-[92%] max-w-7xl mx-auto mt-4 mb-5"
    >
      {ACTIONS.map(({ to, emoji, label, colors, shadow }) => (
        <Link
          key={to}
          to={to}
          className="flex items-center justify-center gap-1.5 px-4 sm:px-2.5 py-2.5 sm:py-2 rounded-xl text-white font-bold text-xs sm:text-[10px] whitespace-nowrap transition-all active:scale-95"
          style={{
            background: `linear-gradient(180deg, ${colors[0]} 0%, ${colors[1]} 50%, ${colors[2]} 100%)`,
            boxShadow: `0 3px 8px ${shadow}, inset 0 1px 0 rgba(255,255,255,0.35), inset 0 -1px 2px rgba(0,0,0,0.15)`,
            border: '1px solid rgba(0,0,0,0.1)',
            textShadow: '0 1px 2px rgba(0,0,0,0.2)',
          }}
        >
          {emoji} {label}
        </Link>
      ))}
    </div>
  )
}

export default QuickActions
